export default __webpack_public_path__ + "additional-address.2ef5389ea0287e50d3ed.svg";